export const EN = {
    en:{
      companyName: "KopaPro",
      langDesc: "English",  
      en:"English",  
      zhTW:"繁",
      zhCN:"简", 
      goodDay:"Good day",
      home: "Home",
      kopapro:"KopaPro",
      addNewShop:"Add New KopaPro",
      addNewDomain: "Buy New Domain",
      refresh:"Refresh",
      refreshFail:"Refresh failed, please try again.",
      kopaproLicenses:"KopaPro Subscription",
      extend:"Extend",
      change:"Change",
      renew: "Renew",
      history:"History",
      subscriptionHistory:"Order History",
      back:"Back",
      assign: "Assign",
      sessionExpired:"Session Expired. Please Login again.",
      addNewMerchant:"Add New Merchant",
      pleaseWait:"Please wait a moment",      
      loading:"Loading...",
      needTrial:"Need a free trial?",
      subDirectly:"You may also subscribe directly by filling in following form",
      curd:{
        save:'Save',
        saveFail:'Save failed, please try again.',
        getFail:'Retrieve failed, please try again.',
        saveSuccess:'Save successfully!'
      },
      kopaproLicense:{    
        details:"Details", 
        client:"Client",   
        code:"KopaPro Code",
        codeHelperText:"A Unique Code for Subdomain",
        desc: "Shop Name",
        descHelperText:"Shop Name",
        sysAdmin:"System Admin",
        rebranch:"Re-Initialize",
        rebranchKey:"Re-Initialize Key",
        plan:{
          plan:"Plan",
          oriPlan:"Current Plan",
          su: "Startup",
          bu: "Business",
          pm: "Premium",
          et: "Enterprise"
        },
        support:{
          support:"Support",
          oriSupport:"Current Support",
          noHotline:"Email / Whatsapp Only",
          hotline:"Email, Whatsapp and Hotline"
        },
        period:"Period",
        extendPeriod:"Extend Period",
        years:"Year(s)",
        months:"Month(s)",
        currency:{
          currency:"Currency",
          hkd:"HKD",
          usd:"USD",
          sgd:"SGD",
          rmb:"RMB"
        },
        amt:"Amount",
        couponCode:"Coupon Code",
        discount:"Discount",
        netAmt:"Net Amount",
        expiryDate:"Expiry Date",
        currentExpiryDate:"Current Expiry Date",
        newExpiryDate:"New Expiry Date",
        activationCode:"Activation Code(For M18 Integration)",
        activationCodeHelperText: "Activation Code for M18 Integration",
        status:"Status",
        serverStatus:"Server",
        createRemindMessage: 'The kopapro code({0}) will be reversed after select payment method, please complete the payment within {1} minutes.',
        paymentReason:{
          KPPPAY_EXTEND_SUBSCRIPTION:"KopaPro Subscription Extension",
          KPPPAY_UPDATE_PLANSUPPORT:"Change of KopaPro Plan",
          KPPPAY_UPDATE_PLANSUPPORT_SU:"Change of KopaPro Plan to Startup",
          KPPPAY_UPDATE_PLANSUPPORT_BU:"Change of KopaPro Plan to Business",
          KPPPAY_UPDATE_PLANSUPPORT_PM:"Change of KopaPro Plan to Premium",
          KPPPAY_UPDATE_PLANSUPPORT_ET:"Change of KopaPro Plan to Enterprise",
          KPP_NEW_SUB:"KopaPro Subscription",
          KPP_NEW_SUB_TRIAL:"Free Trial",
          KPPPAY_UPDATE_SUPPORT_NOHOTLINE:'Change of KopaPro Support to Email / Whatsapp Only',
          KPPPAY_UPDATE_SUPPORT_HOTLINE:'Change of KopaPro Support to Email, Whatsapp and Hotline',
          KPPPAY_UPDATE_MONTH:'Change of KopaPro Period to ',
          KPPPAY_UPDATE_YEAR:'Change of KopaPro Period to ',
          KPPPAY_UPDATE_CUR_HKD:'Change of KopaPro Payment Currency to HKD',
          KPPPAY_UPDATE_CUR_USD:'Change of KopaPro Payment Currency to USD',
          KPPPAY_UPDATE_CUR_RMB:'Change of KopaPro Payment Currency to RMB',
          KPP_TRIAL_EXTEND:'KopaPro Free Trial Extension'
        },
        invalidRefCode: 'Promotion code not exists.',
        residue:"Remaining Amount",
        visit:"Edit eShop",
        payAndSubscribe:"Pay & Subscribe",
        payAndExtend:"Pay & Extend",
        paid:"Paid",
        pending:"Pending",
        cancelled:"Canceled",
        active:"Active",
        expired:"Expired",
        running:"Running",
        terminated:"Terminated",
        ended:"Terminated",
        finished:"Finished",
        pay:"Pay",
        createDate:"Create Date",
        date:"Date",
        extendTrial:"Extend Free Trial for 14 more days",
        accessFail:"Error in accessing KopaPro, please contact KopaPro Support Team.",
        invalidCode:"Failed to access the KopaPro Details. Please Choose the correct KopaPro.",
        trialExpired:"Your free trial is expired",
        task:{
          Branch:"Setup Server Environment",
          Migrate:"Migrate Data to new Server Environment"
        },
        showServerTask:"Show Server Tasks",
        planChange:"You are going to change plan from #oPlan# to #nPlan#.",
        planChangeWarn1:"Data migration will be carried out once you finish payment.",
        planChangeWarn2: "It may takes hours depends on data volumne on your current KopaPro",
        planChangeWarn3: "To confirm change, please input the confirm text:",
        invalidPlanChange: "Sorry, KopaPro cannot be downgraded.",
        refCode: "Promotion Code"
      },
      dashboard: {
        title: "Welcome to KopaPro Account",
        missingInfo: {
          title: "Complete your account information",
          notCompletedMsg: "You have not completed your account information. ",
          notCompletedMsg2: "Please go to accounting setting and provide your basic and billing information up to date.",
          action: "Edit Account"
        },
        addTrial:{
          title: "Start a trial now",
          title2: "Enjoy your free trial - %kppCode%",
          msg:"Get one month of free trial",
          msg2: "Try out the software, no credit card required",
          action1: "Try it Free",
          action2: "Subscribe your trial KopaPro Now",
          action3: "Start building your KopaPro",
          countDown: "%countDownDays% days %countDownTime% left",
          expired:"Trial Period is Ended"
        },
        trialPeriod: {
          title: 'Trial remaining:',
          expireAt: "Expire At: "
        }
      },
      merchant:{
        basicInfo:"Basic Info.",
        secondAuth:"Second Authentication",
        billingInfo:"Billing Info.",
        merchant:"Merchant",
        email:"Email (Merchant ID)",        
        firstName:"First Name",
        lastName:"Last Name",
        name: "Name",
        companyName:"Company Name",
        companyAddr:"Company Address",
        addr1:"Line 1",
        addr2:"Line 2",
        zipCode:"Zip Code",
        city:"City",
        province:"Province",
        country: "Country",                
        areaCode: "Area Code",
        mobile: "Mobile Number",
        tel: "Tel. Number",
        compTel:"Company Tel.",
        progCode:"Program Code",
        billingInfoHint: 'Fill in the billing information for this account' ,
        basicInfoHint: 'Fill in the basic information for this account',
      },
      signUp:{
        title: "Sign Up",
        password:"Password",
        confirmPw:"Confirm Password",
        successInfo:"Sign Up successfully.",
        notMatchPassword: "Not match password",
      },
      domains: {
        title: "Domains",
        domainName: 'Domain',
        createAt: 'Create At',
        expires: 'Expires',
        status: 'Status',
        renewAuto: 'Auto Renew',
        mappedKopaPro: "Mapped KopaPro",
        renewDeadline: 'Renew Deadline',
        renewable: 'Renewable',
        ownerEmail:"Domain Owner Email",   
        companyName:"Company Name",
        acceptAgreement: "I have read and agreed to all terms of the {0}",
        acceptAgreementLinkText: "Domain Name Registration Agreement",
        icannPrivacy:"ICANN privacy",
        assignToKopapro: "Assign {0} to KopaPro",
        perYear: "/yr",
        nextYearRenew:'Next Time Renew',
        perYearCharge:'{0} {1} per year',
        domainContactLabel:'Fill in the information for the domain',
        purchasePrivacy: "Purchase WHOIS Privacy Protection",
        suggestion: "Suggestions",
        otherSuggestion: "Other Suggestions",
        available: 'Domain Available',
        notAvailable: 'Domain not Available',
        statuses: {
          InActive: "Inactive",
          Active: "Active",
          Suspended: "Suspended",
          "Pending Delete Restorable": "Pending Delete Restorable",
          Deleted: "Deleted",
          Archived: "Archived",
          "Pending Verification": "Pending Verification",
          "Failed Verification": "Failed Verification",
          notAvailable: "Not Available",
          owned: "Owned by You",
          taken: "This domain is taken",
          notSupported: "Not Supported",
          processing: "Processing"
        },
        singleYear: "{0} Year",
        multiYears: "{0} Years",
        buyNew: {
          subTitle: "Buy New Domain",
          enterDomain: "Enter the domain you want to buy.",
          selectDomain: "Select Domain",
          provideInfo: "Provide Information",
          payment: "Payment",
        },
        payment: {
          title: "Order Information",
          domainOwnerInfo: "Domain Owner Information",
          whoisPrivacy: "WHOIS Privacy Protection",
          whoisDetail: "When you enable this service for your domain name, we replace your contact details in the WHOIS information with our generic contact details. Thus, your personal information won't be displayed in public registration record.",
          privacy: "Privacy & Agreement",
          agreementStatement: "You confirmed you have read and agreed to the {0} and {1}."
        },
        errors: {
          "invalid_shop_license_code": "Invalid Shop",
          "invalid_tlds": "Top-level domain not supported.",
          "fetch_fail": "Cannot find any suggested domains, please use another keyword.",
          invalidCharacters: "Invalid characters."
        },
        alerts: {
          expiry: {
            title: "Domain Name Expiry Reminder",
            message: "Your domain is going to expriy. Take immediate action when you receive this reminder to avoid the potential of losing your domain name.",
          },
          expired: {
            title: "Domain Expired Reminder",
            message: "Your domain is expired. Take immediate action when you receive this reminder to avoid the potential of losing your domain name.",
          },
          assignedDomain: {
            message: "You assigned {0} to KopaPro - {1}. The domain will be effective once you publish KopaPro in M18."
          }
        },
        contact: {
          englishOnly: "All the fields are required to be filled in English."
        },
        delayRecords: "If the domain you just purchased is not showing in the table, please wait a moment and refresh after a few seconds."
      },
     
      general: {
        errors: {
          required: "This field is required.",
          maxLength: "Cannot more than {0} characters.",
          minLength: "Cannot less than {0} characters.",
          phone: "Invalid phone number.",
          email: "Invalid email address.",
          currentPassword: "Incorrect current password.",
          notMatchPassword: "Not match new password",
          requiredPassword: "This field is required if you want to change the password",
          englishOnly: "This field must be filled in English only.",
          alphanumericOnly: "This field must be filled in English characters and numbers only.",
          alphanumericSymbolOnly: "This field must be filled in English characters, numbers, and allowed symbols(+-_&(),.:'`;/) only.",
          invalidEmailPassword: "Your password or email address is incorrect."
        },        
        email:"Email",   
        emailAddress:"Email Address",   
        firstName:"First Name",
        lastName:"Last Name",
        companyName:"Company Name",
        phoneNumber: "Phone Number",
        addr1:"Address Line 1",
        addr2:"Address Line 2",
        postalCode:"Postal Code",
        city:"City",
        state: "State / Province / Territory",
        province: " Province",
        country: "Country",
        noRecord: "No Records",
        exampleShort: "e.g.:",
        cancel: "Cancel",
        confirm: "Confirm",
        back: "Back",
        next: "Next",
        pay: "Pay",
        save: "Save",
        signUp: "Sign Up",
        signIn: "Sign In",
        select: "Select",
        search: "Search",
        logout: "Logout",
        total: 'Total',
        changePassword: "Change Password",
        account: "Account",
        password: "Password",
        currentPassword: "Current Password",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        haveAccount: "Already have an account?",
        noAccount:"Don't have an account?",
        forgotPassword: "Forgot Password?",
        forgotPasswordTitle: "Forgot your password?",
        resetPasswordTitle: "Reset Password",
        returnToLogin: "Back to login",
        loginFailed: "Invalid Email Address or Password",
        resetEmailSent:"Reset Email is sent. Please check your email.",
        resetSuccessFully:"Password is updated.",
        resetPwEmail:"Please provide us your email. It must be the same as your KopaPro account.",
        hasPendingPayment:"There are pending Payments",
        trialCheckEmail:"Please check your email for trial account info.",
        yes:"Yes",
        no:"No",
        verifyEmailTitle:"Please verify your email",
        verifyEmailMsg:"You're almost there! We sent an email to",
        verifyEmailMsg2:"Just click on the link in that email to complete your sign up.",
        verifyEmailMsg3:"If you don't see it, you may need to check your junk folder.",
        verifyEmailMsg4:"Still can't find the email?",
        resendEmail:"Resend Email",        
        backToSignUp:"Return to sign up",
        resendEmailOK:"Resend Email successfully",
        verifying:"Please wait a moment, verifying...",
        verifyOK:"Verify successfully",
        loginConsole:"Login Subscription Console",
        reloginKppSite: "Please re-login your KopaPro Site to have updated Expiry Date",
      },
      footer: {
        contact: "Contact",
        tos: "Terms of Service",
        privacyPolicy: "Privacy Policy",
      },
      account: {
        title: "Account Information"
      },
      KppResponse:{
        DUPCODE: "Duplicated Account",
        DUPSHOP: "KopaPro Code already exists",
        NOTFOUND: "Entity Not Found",
        VALIDFAIL: "Invalid Field value(s)",
        ILLEGAL_ALPHANUMERIC: "Must contain only letters and numbers",
        MAX_LENGTH:"Field exists maximum length",
        INVALID_INPUT_FORMAT:"Invalid Input Format",
        TRIAL_CREATED:"You already has a trial KopaPro",
        NO_DOWNGRADE:"Cannot downgrade current plan",
        NO_DOWNPERIOD:"Cannot shorten subscription periods",
        LOWERCASE:"Field value must be lower cases"
      },
      countdown: {
        days: "days",
        hours: "Hours",
        mins: "Mins",
        secs: "Secs",
      }, 
      payment: {
        title: "Payment",
        initError: 'Cannot initialize payment, please try again.',
        instruction: "Please scan the QR Code to complete payment:",
        selectMethod: "Select Payment Method",
        methods: {
          alipay: "Alipay",
          wechatPay: "Wechat Pay",
          creditCard: "Credit Card / Apple Pay / Google Pay"
        }
      },
      wallet: {
        shortTitle: "MPCSB",
        title: 'Merchant Pre-paid Courier Service Balance (MPCSB)',
        overview: 'Overview',
        statement: 'Statement',
        transactions: 'Transactions',
        currentBalance: "Current Balance",
        openingBalance: "Opening Balance",
        closingBalance: "Closing Balance",
        costIn7Days: 'Courier Order Cost in Last 7 Days',
        costIn30Days: 'Courier Order Cost in Last 30 Days',
        recentDeposit: 'Recent Deposit',
        depositDialogTitle: 'Deposit',
        recentTransactions: 'Recent Transactions',
        date: 'Date',
        description: 'Description',
        type: 'Type',
        types: {
          deposit: 'Deposit',
          expense: 'Expense',
        },
        amount : 'Amount',
        actions: {
          deposit: 'Deposit',
          enable:'Enable',
          accept: 'Accept & Enable',
          getStatement: 'Preview Statement',
          exportStatement: 'Download Statement in PDF',
        },
        pending: 'Pending',
        statementDate: 'Statement Date',
        topUp: 'Top-Up',
        use: 'Use',
        dateTo: ' to ',
        walletStatement: 'MPCSB Statement',
        balance: 'Balance',
        depositLabel: 'Please enter amount you want to deposit:',
        enableDialogTitle: 'Enable Service',
        askEnableLabel: 'Enjoy Automatic Order Generation to Save Your Time and Reduce Error.',
        currency: "Currency",
        errors: {
          minAmount: "Minimum deposit amount is {0} {1}.",
          maxAmount: "Maximum deposit amount is {0} {1}.",
        },
        transactionDetails:{
          deposit: "Deposit to account ({0})",
          adjustment: "Adjustment of ",
          reverseAdjustment: "Reverse adjustment of ",
        }
      },
      plugins: {
        title: 'Plugins',
        detailTitle: 'Plugin Detail',
        information: 'Information',
        name: "Name",
        description: "Description",
        createAt: "Created At",
        developerEmail: "Developer Email",
        contactEmail: "Contact Email",
        isApproved: "Approved",
        lastUpdateAt: "Last Update At",
        currentVersion: "Current Version",
        callToActionOverlay: "Call-to-action Overlay",
        status: "Status",
        allowTrial: 'Allow Trial',
        trialPeriod : 'Trial Period (Days)',
        newPlugin: 'New Plugin',
        editPlugin: 'Edit Plugin',
        effectiveDateFrom: "Effective Date (from)",
        effectiveDateTo: "Effective Date (to)",
        actions: {
          add: "Add"
        },
        subscriptionHistory: 'Subscription History',
        pricing: {
          title: "Pricing",
          pricingModel: "Pricing Model",
          effectiveDate: "Effective Date",
          monthlyPrice: "Monthly Price",
          annualPrice: "Annual Date",
          currency: "Currency",
          amount: "Amount"

        },
        versions: {
          title: "Versions",
          versionNo: 'Version Number'
        }
      }        
    }
     
  }
